import { gql } from "@apollo/client";

export const deleteHostedLens = gql`
    mutation deleteHostedLens($lensID: ID!, $organizationId: ID!) {
        deleteHostedLens(input: { id: $lensID, organizationId: $organizationId })
    }
`;
